import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "XhsNoteListContainer"
};
const _hoisted_2 = {
  key: 0,
  src: "https://cdn.waityou.online/5065a78a-1e66-755f-d268-ab441500792e.svg",
  class: "sqr14"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_text = _resolveComponent("el-text");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_BatterTableDataView, {
    "table-id": 4,
    onOnFetchData: $options.onFetchData
  }, {
    title: _withCtx(data => [_createVNode(_component_el_text, {
      truncated: "",
      class: "ptr",
      style: _normalizeStyle(`color: ${data?.data?.noteAuthor?.us ? 'red' : '#009FFF'};`),
      onClick: $event => $options.look(data.rowId)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(data.rowData), 1)]),
      _: 2
    }, 1032, ["style", "onClick"])]),
    noteAuthor: _withCtx(data => [_createVNode(_component_el_row, {
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(data?.rowData?.nickName), 1), data?.data?.noteAuthor?.us ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true)]),
      _: 2
    }, 1024)]),
    operate: _withCtx(data => [data.data.noteId ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      type: "primary",
      size: "small",
      onClick: $event => $options.lookNote(data.data)
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("查看/更新")])),
      _: 2
    }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["onOnFetchData"])]);
}